import React, { useState, useEffect, useRef } from 'react';
import { FaCalendarAlt } from 'react-icons/fa';
import DatePicker from 'react-datepicker';
import dayjs from '../helpers/dates';
import { fieldFormat } from '../helpers/utils';

interface DateFieldProps {
  name?: string;
  label?: string;
  selected?: any;
  onChange: (date: string | null) => void;
  showPastDue?: boolean;
}

const DateField = ({
  name,
  label,
  selected,
  onChange,
  showPastDue,
}: DateFieldProps) => {
  const [pastDue, setPastDue] = useState(false);
  const [val, setVal] = useState<any>(false);
  const [focus, setFocus] = useState(false);
  const transientVal = useRef<any>(false);
  const checkPastDue = (date: any) => {
    if (!showPastDue) {
      return;
    }
    if (dayjs().format('YYYYMMDD') > dayjs(date).format('YYYYMMDD')) {
      setPastDue(true);
    } else {
      setPastDue(false);
    }
  };

  const changeDate = (date: any) => {
    setVal(date);
  };

  const handleBlur = () => {
    if (transientVal.current != val) {
      transientVal.current = val;
      const date = val;
      checkPastDue(date);
      setFocus(true);

      // Handle null or invalid dates
      if (!date) {
        onChange(null);
        return;
      }

      try {
        const d = dayjs(date);
        const formattedDate = d.isValid()
          ? d.format('YYYY-MM-DD')
          : 'Invalid date';
        // Validate the formatted date
        if (formattedDate === 'Invalid date') {
          onChange(null);
        } else {
          onChange(formattedDate);
        }
      } catch (error) {
        console.warn('Date formatting error:', error);
        onChange(null);
      }
    }
  };
  const prevSelected = useRef<any>(null);
  useEffect(() => {
    if (
      selected &&
      selected !== 'Invalid date' &&
      selected !== '' &&
      selected !== prevSelected.current
    ) {
      prevSelected.current = selected;
      try {
        const dayjsDate = dayjs(selected);
        if (dayjsDate.isValid()) {
          setVal(dayjsDate.toDate());
          checkPastDue(dayjsDate.toDate());
        }
      } catch (error) {
        console.warn('Date parsing error:', error);
        // Don't set invalid dates
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  return (
    <>
      <div
        className={
          label
            ? 'deadline-field--container-block'
            : 'deadline-field--container-inline'
        }
      >
        {label && <label>{label}</label>}
        <div className="deadline-field--container datepicker">
          <DatePicker
            id={`${fieldFormat(name, '-edit-field')}`}
            showIcon={!label}
            icon={<FaCalendarAlt />}
            selected={val}
            onChange={(date) => changeDate(date)}
            onBlur={handleBlur}
            dateFormat="MM/dd/yyyy"
            shouldCloseOnSelect={true}
            minDate={new Date('2000-01-01')}
            maxDate={new Date('2100-01-01')}
            placeholderText="MM/DD/YYYY"
            popperPlacement="right"
            // Render the calendar at <body> level so a scrollable container
            // (e.g. a modal body) can't clip it. Mirrors the menuPortalTarget
            // react-select already uses in components/Select.tsx.
            portalId="datepicker-portal"
            className={
              pastDue ? 'deadline-field deadline-field-due' : 'deadline-field'
            }
          />
        </div>
      </div>
    </>
  );
};

export default DateField;
